import React, { SVGAttributes } from 'react'

export const Play: React.FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.75 10.701C19.75 11.2783 19.75 12.7217 18.75 13.299L8.25 19.3612C7.25 19.9386 6 19.2169 6 18.0622L6 5.93782C6 4.78312 7.25 4.06143 8.25 4.63878L18.75 10.701Z"
    />
  </svg>
)
